import { render } from "./EditPayments.vue?vue&type=template&id=f1ba11d4"
import script from "./EditPayments.vue?vue&type=script&lang=js"
export * from "./EditPayments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__